"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectMemberMultiSelectDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _common = require("./common");
var _ProjectMemberMultiSelectValueTag = require("./ProjectMemberMultiSelectValueTag");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _featureFlags = require("../../utils/featureFlags");
var _ProjectMemberMultiSelectNewDropdown = _interopRequireDefault(require("./ProjectMemberMultiSelectNewDropdown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ProjectMemberMultiSelectDropdown = _ref => {
  let {
    name,
    selectedOptions,
    onChange,
    container,
    shouldIncludeMemberFn,
    isMemberInvalidFn = () => false,
    invalid = false,
    shouldIncludeEmpty = false
  } = _ref;
  const members = (0, _common.useGroupedProjectMembersAsOptions)({
    shouldIncludeMemberFn,
    shouldIncludeEmpty
  });
  // if the options are not memoized with an empty dependency array
  //  the new alloy dropdown cant handle item deselection in the menu
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const options = (0, _react.useMemo)(() => members, []);
  let {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase2Batch1);
  shouldUseNewDropdown = true;
  const groupedOptions = (0, _react.useMemo)(() => {
    // TODO: remove when component migration is finalized
    if (shouldUseNewDropdown) {
      options.forEach(group => group.items = group.options);
    }
    return options;
  }, [options, shouldUseNewDropdown]);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.GroupedSelectBoxWrapper, {
    name: name,
    multiple: true,
    showValueAsTags: true,
    placeholder: T.translate("projectMemberPlaceholder"),
    value: selectedOptions,
    invalid: invalid,
    defaultInputValue: "",
    options: groupedOptions,
    onChange: newSelectedOptions => {
      onChange(newSelectedOptions || []);
    },
    clearable: true,
    searchable: true,
    container: container,
    valueTagRenderer: option => {
      return /*#__PURE__*/_react.default.createElement(_ProjectMemberMultiSelectValueTag.ProjectMemberMultiSelectValueTag, _extends({}, option, {
        invalid: isMemberInvalidFn(option),
        onRemove: value => {
          onChange(selectedOptions.filter(option => option.value !== value));
        }
      }));
    }
  });
  const NewDropdown = () => {
    return /*#__PURE__*/_react.default.createElement(_ProjectMemberMultiSelectNewDropdown.default, {
      members: groupedOptions,
      selectedOptions: selectedOptions,
      onChange: onChange,
      isMemberInvalidFn: isMemberInvalidFn
    });
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.ProjectMemberMultiSelectDropdown = ProjectMemberMultiSelectDropdown;
//# sourceMappingURL=ProjectMemberMultiSelectDropdown.js.map